import { getEnvConfig } from './envConfig';

export function getPublicBaseUrl(): string {
	if (typeof window === 'undefined') {
		return '';
	}

	const envPublicUrl = getEnvConfig().PUBLIC_BASE_URL;
	if (envPublicUrl) {
		return envPublicUrl;
	}

	// fork-specific: PUBLIC_BASE_URL takes precedence; this is the iframe-aware fallback.
	// oxlint-disable-next-line signoz/no-raw-absolute-path
	return window.location.origin;
}

export function getPublicUrl(pathname?: string, search?: string): string {
	if (typeof window === 'undefined') {
		return `${pathname ?? ''}${search ?? ''}`;
	}

	const baseUrl = getPublicBaseUrl();
	const path = pathname ?? window.location.pathname;
	const query = search ?? window.location.search;

	return `${baseUrl}${path}${query}`;
}

export function getAlertSourceUrl(): string {
	return getPublicUrl();
}
